import {atom, selectorFamily, useSetRecoilState} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getImports} = api.imports;

type Params = Parameters<typeof getImports>[0] & {
  taskId?: string;
};

const getImportsRefresh = atom<number>({
  key: 'getImportsRefresh',
  default: 0,
});

export const useGetImportsRefresh = () => {
  const refreshFn = useSetRecoilState(getImportsRefresh);
  return () => refreshFn((prev) => prev + 1);
};

const getImportsQuery = selectorFamily({
  key: 'getImports',
  get(params: Params) {
    return async ({get}) => {
      get(getImportsRefresh);
      try {
        if (!params.taskId) throw new Error('taskId is required');
        const {data} = await getImports(params, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetImportsQuery = createQuery(getImportsQuery, getImportsRefresh);
